import styled, { css } from 'styled-components';

export const FormElement = styled.form`
  ${({ theme, ...props }) => {
    return css`
      max-width: 56rem;
      margin: 0 auto;
    `;
  }};
`;

export const ActionElement = styled.div`
  ${({ theme, ...props }) => {
    return css`
      display: flex;
      justify-content: space-between;
      padding: ${theme.spacing.base} 0;

      border-top: 2px solid ${theme.color.neutral_200};
      > button:last-of-type {
        margin-left: auto;
        margin-right: 0;
      }
    `;
  }};
`;

export const FlexElement = styled.div`
  ${({ theme, ...props }) => {
    return css`
      display: flex;
      justify-content: space-between;
      gap: 1rem;
      > div {
        flex-grow: 1;
        width: 100%;
      }
    `;
  }};
`;

export const FeedbackContainer = styled.div`
  ${({ theme, ...props }) => {
    return css`
      display: flex;
      flex-direction: column;
      gap: 1rem;
      margin-bottom: 1rem;
    `;
  }};
`;
